/**
 * 保留数字指定的精度
 * @param value 数字
 * @param digits 需要保留的小数精度
 * @param mode 精度计算方式, round:四舍五入 ceil:向上取整 floor:向下取整
 * @example $toFixed(100, 2) => "100.00"
 */

export default function (value: number = 0, digits: number = 0, mode: 'round' | 'ceil' | 'floor' = 'floor'): any{
	const num: number = Math[mode](Number(value) * Math.pow(10, digits)) / Math.pow(10, digits);
	const ary: Array<string> = String(num).split('.');
	let decimal: Array<string> = (ary[1] || '').split('');
	while (decimal.length < digits) {
		decimal.push('0');
	}
	decimal = decimal.slice(0, digits);
	if (decimal.length) {
		ary[1] = decimal.toString();
	}
	return ary.join('.');
}
